<script setup lang="ts">
  import { ref } from "vue";
  import { storeToRefs } from "pinia";
  import { CloudUpload } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { Badge } from "@/components/ui/badge";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";
  import ImageLibraryUploadDialog from "@/components/MCampaign/ImageLibrary/ImageLibraryUploadDialog.vue";

  const assetLibraryStore = useMAssetLibraryStore();
  const { totalCount } = storeToRefs(assetLibraryStore);

  const uploadOpen = ref(false);
  const openUploadDialog = () => (uploadOpen.value = true);
</script>

<template>
  <div class="flex items-center justify-between gap-4 border-b px-6 py-4">
    <div class="flex items-center gap-3">
      <h2 class="heading-title">Asset library</h2>
      <Badge variant="outline">{{ totalCount }} asset{{ totalCount === 1 ? "" : "s" }}</Badge>
    </div>

    <div class="flex items-center gap-3">
      <Button
        variant="outline"
        @click="openUploadDialog">
        <CloudUpload class="mr-1 h-4 w-4" />
        Upload
      </Button>

      <slot name="actions" />
    </div>

    <ImageLibraryUploadDialog v-model:open="uploadOpen" />
  </div>
</template>
